import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const FooterMainField = styled.footer(
	({ theme }) => css`
		* {
			font-family: ${theme.direction === 'rtl'
				? '"YekanBakh", -apple-system, BlinkMacSystemFont, "Helvetica Neue", Helvetica, "Segoe UI", Arial, Roboto, "PingFang SC", "Miui", "Hiragino Sans GB", "Microsoft Yahei", sans-serif'
				: 'Gilroy'};
		}
		width: 100%;
		background: var(--color-background-section-1);
		padding: 28px 0;
		border-top: 1px solid #e0e2e6;
		display: flex;
		align-items: center;
		flex-direction: column;
		direction: ${theme.direction};

		@media (min-width: 992px) {
			padding: 40px 0 32px;
		}

		.footer_flex_container {
			display: flex;
			flex-direction: column;
			width: 100%;

			@media (min-width: 768px) {
				display: flex;
			}

			.footer_container {
				padding-bottom: 0.75rem;
				margin: 0 1rem;
				border-bottom: 1px solid #e5e7ea;
				display: flex;
				flex-direction: column;
				order: 1;

				@media (min-width: 576px) {
					width: 540px;
					margin: 0 auto;
					padding-bottom: 0;
					border-bottom: none;
				}
				@media (min-width: 768px) {
					width: 720px;
				}
				@media (min-width: 992px) {
					width: 960px;
					flex-direction: row;
					justify-content: space-between;
				}
				@media (min-width: 1200px) {
					width: 1140px;
				}
				@media (min-width: 1400px) {
					width: 1320px;
				}

				.column_container {
					display: flex;
					flex-direction: column;

					.footer_links_container {
						display: none;

						&.active {
							display: flex;
							flex-direction: column;
							gap: 16px;
							margin-bottom: 12px;
							padding-left: 16px;

							@media (min-width: 992px) {
								margin-top: 0;
								padding-left: 0;
							}
						}

						@media (min-width: 992px) {
							display: flex;
							gap: 16px;
							flex-direction: column;
						}
					}

					.column_header {
						display: flex;
						justify-content: space-between;

						h4 {
							margin-bottom: 1.5rem;
							font-weight: 500;
							font-size: 1rem;
							line-height: 20px;

							@media (min-width: 992px) {
								margin-bottom: 24px;
								font-weight: 700;
							}
						}

						@media (min-width: 576px) {
							img {
								width: 16px;
							}
						}

						@media (min-width: 992px) {
							img {
								display: none;
							}
						}
					}

					.footer_item {
						color: var(--color-text-2);
						font-size: 0.875rem;
						font-weight: 300;
						cursor: pointer;
					}

					.footer_img {
						height: 35px;

						@media (min-width: 992px) {
							margin-bottom: 24px;
						}
					}

					&.column_logo {
						order: 1;
						align-items: flex-start;

						@media (min-width: 992px) {
							order: 7;
							align-items: center;
						}
					}

					&.column_company,
					&.column_products,
					&.column_support,
					&.column_services {
						order: 2;
						margin: 32px 0 24px;

						@media (min-width: 992px) {
							margin: 0;
						}
					}

					&.column_services {
						margin: 0;

						@media (min-width: 576px) {
							margin: 0 0 24px;
						}
					}

					&.column_buy_crypto {
						order: 6;
						display: none;

						@media (min-width: 992px) {
							display: flex;
						}
					}

					.footer_qr_container {
						display: none;

						@media (min-width: 992px) {
							display: flex;
							flex-direction: column;
							align-items: center;
							gap: 8px;

							.footer_qr_square {
								width: 144px;
								height: 144px;
								border: 1px solid #000000;
								border-radius: 24px;
								display: flex;
								align-items: center;
								justify-content: center;
								padding: 10px;

								img {
									width: -webkit-fill-available;
									border-radius: 12px;
								}
							}

							.footer_qr_text {
								font-weight: 300;
								color: var(--color-text-1);
								font-size: 0.625rem;
							}
						}
					}
				}
			}

			.footer_divider {
				width: 100%;
				height: 2px;
				background: radial-gradient(black 20%, transparent 80%);
				position: relative;
				margin-bottom: 25px;
				order: 4;

				@media (min-width: 576px) {
					order: 3;
					margin-bottom: 16px;
				}

				img {
					position: absolute;
					bottom: -18.8px;
					right: 40px;

					@media (min-width: 576px) {
						right: 40%;
						width: 24px;
						bottom: -11px;
					}

					@media (min-width: 768px) {
						right: 130px;
					}
				}
			}

			.footer_copy_socials {
				order: 5;
				display: flex;
				margin-top: 1rem;
				flex-direction: column;
				align-self: center;

				.holder {
					display: none;

					@media (min-width: 576px) {
						display: flex;
						flex: 1 0 0%;
					}
				}

				.footer_socials_container {
					display: flex;
					gap: 12px;
					justify-content: center;

					@media (min-width: 576px) {
						flex: 1 0 0%;
						justify-content: flex-start;
					}

					.social_items {
						display: flex;
						gap: 12px;
					}
				}

				.footer_copyright {
					display: flex;
					justify-content: center;
					color: var(--color-text-2);
					font-weight: 300;
					font-size: 0.875rem;
					line-height: 17px;
					margin-top: 1rem;
				}

				@media (min-width: 576px) {
					width: 540px;
					flex-direction: row;
					justify-content: space-between;
					align-items: center;
					flex: 1 0 0%;

					.footer_copyright {
						justify-content: flex-start;
						margin-top: 0;
					}
				}

				@media (min-width: 768px) {
					width: 720px;
				}
				@media (min-width: 992px) {
					width: 960px;
				}
				@media (min-width: 1200px) {
					width: 1140px;
				}
				@media (min-width: 1400px) {
					width: 1320px;
				}
			}

			.risk_container {
				order: 3;
				padding: 1rem;
				background-color: #2d3339;

				@media (min-width: 576px) {
					padding: 24px 0 36px;
				}
				@media (min-width: 992px) {
					padding: 24px 0 44px;
				}

				.risk_title {
					color: #e5e7ea;
					margin-bottom: 16px;
					font-size: 1rem;
					line-height: 20px;
					font-weight: 500;

					@media (min-width: 992px) {
						font-size: 1.125rem;
						line-height: 22px;
					}
				}

				.disclaimer {
					@media (min-width: 576px) {
						width: 540px;
						margin: 0 auto;
					}
					@media (min-width: 768px) {
						width: 720px;
					}
					@media (min-width: 992px) {
						width: 960px;
					}
					@media (min-width: 1200px) {
						width: 1140px;
					}
					@media (min-width: 1400px) {
						width: 1320px;
					}
				}

				p {
					font-size: 0.875rem;
					line-height: ${theme.direction === 'rtl' ? '25px' : '17px'};
					color: #a7b0b8;
				}
			}

			.forex_container {
				order: 2;
				padding: 1rem;

				@media (min-width: 576px) {
					width: 540px;
					padding: 24px 0 36px;
					margin: 0 auto;
				}
				@media (min-width: 768px) {
					width: 720px;
				}
				@media (min-width: 992px) {
					padding: 24px 0 44px;
					width: 960px;
				}
				@media (min-width: 1200px) {
					width: 1140px;
				}
				@media (min-width: 1400px) {
					width: 1320px;
				}

				.risk_title {
					color: #e5e7ea;
					margin-bottom: 16px;
					font-size: 1rem;
					line-height: 20px;
					font-weight: 500;

					@media (min-width: 992px) {
						font-size: 1.125rem;
						line-height: 22px;
					}
				}

				p {
					font-size: 0.875rem;
					line-height: ${theme.direction === 'rtl' ? '25px' : '17px'};
					color: #000;
					padding-top: 1rem;
				}

				br {
					display: block;
					content: ' ';
					margin-top: 0.5rem;
				}
			}
		}
	`,
);

export const FooterContact = styled.div({
	display: 'flex',
	flexDirection: 'column-reverse',
	'.footer_platforms': {
		color: 'var(--color-text-1)',

		marginRight: '4px',
		fontWeight: 500,
		fontSize: '1rem',
		lineHeight: '20px',
		'.platform_items': {
			display: 'flex',
			gap: '1rem',
		},
	},
	'.contacts': {
		display: 'none',

		'@media(min-width:992px)': {
			display: 'block',
		},
	},
	'.contacts_item': {
		display: 'flex',
		alignItems: 'center',
		gap: '5px',
	},
	'.contacts_link': {
		fontWeight: 500,
		fontSize: '1rem',
		lineHeight: '20px',
		color: '#000',

		'@media(min-width:992px)': {
			display: 'none',
		},
	},
	'.title_desktop': {
		display: 'none',
	},
	'.platforms': {
		display: 'flex',
		justifyContent: 'space-between',

		'@media(min-width:992px)': {
			flexDirection: 'column',
		},
	},
	'@media(min-width: 576px)': {
		'.title_phone': {
			display: 'none',
		},
		'.title_desktop': {
			display: 'block',
		},
	},
	'@media(min-width: 992px)': {
		flexDirection: 'column',
		'.column_container': {
			'&:last-of-type': {
				paddingTop: '2.7rem',
			},
		},
	},
});
